import React from 'react';
import PublicMenuPage from 'modules/restaurant/public/PublicMenuPage';

export default function PublicRestaurantMenu() {
    return <PublicMenuPage />;
}
